import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useCommonFetch from "../../../hooks/useCommonFetch";
import {
  createLeaveType,
  getLeaveTypeList,
  updateLeaveType,
} from "../../../services/workspace/leaveType.service";
import { deleteDepartment } from "../../../services/workspace/department.service";
import PageTableHeader from "../../components/pageTableHeader/pageTableHeader";
import CommonTable from "../../components/table/table";
import CommonModal from "../../components/modals/commonModel";
import CommonForm from "../../components/form/form";
import BottomDrawer from "../common/drawer/bottomDrawer";

const AddLeads = () => {
  const navigate = useNavigate();

  const [isOpenSheet, setIsOpenSheet] = useState(false);

  const handleAddDepartmentClick = () => {
    setIsOpenSheet(true);
  };

  const actions_type = {
    VIEW: "VIEW",
    DELETE: "DELETE",
    ADD_EDIT: "ADD_EDIT",
  };

  const breadcrumbs = [
    { label: "Leads", path: "/leads" },
    { label: "Add", path: "" },
  ];

  const leadFormFields = [
    // Basic Details Section

    { sectionTitle: "Basic Details" },
    {
      name: "applicant_name",
      label: "Applicant Name",
      type: "select",
      required: true,
      placeholder: "Select",
      addmoreClick: true,
      onAddMore: handleAddDepartmentClick,
    },
    {
      name: "phone_number",
      label: "Phone Number",
      type: "text",
      required: true,
      placeholder: "Enter here",
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      placeholder: "Enter here",
    },
    {
      name: "dob",
      label: "Date Of Birth",
      type: "date",
      placeholder: "Select",
    },
    {
      name: "gender",
      label: "Gender",
      type: "select",
      placeholder: "Select",
    },
    {
      name: "father_name",
      label: "Father Name",
      type: "text",
      placeholder: "Enter here",
    },
    {
      name: "mother_name",
      label: "Mother Name",
      type: "text",
      placeholder: "Enter here",
    },
    {
      name: "nationality",
      label: "Nationality",
      type: "select",
      placeholder: "Select",
    },
    {
      name: "state",
      label: "State",
      type: "select",
      placeholder: "Select",
    },
    {
      name: "city",
      label: "City",
      type: "text",
      placeholder: "Enter here",
    },
    {
      name: "pincode",
      label: "Pincode",
      type: "text",
      placeholder: "Enter here",
    },
    {
      name: "current_address",
      label: "Current Address",
      type: "text",
      placeholder: "Enter here",
    },

    // Loan Details Section
    { sectionTitle: "Loan Details" },
    {
      name: "loan_type",
      label: "Loan Type",
      type: "select",
      placeholder: "Select",
    },
    {
      name: "loan_amount",
      label: "Loan Amount",
      type: "text",
      placeholder: "Enter here",
    },
    {
      name: "tenure",
      label: "Tenure Range (months)",
      type: "text",
      placeholder: "Enter here",
    },
    {
      name: "occupation_type",
      label: "Occupation Type",
      type: "select",
      placeholder: "Select",
    },
    {
      name: "collateral_applicable",
      label: "Collateral Applicable",
      type: "select",
      placeholder: "Select",
    },
    {
      name: "collateral_type",
      label: "Collateral Type",
      type: "select",
      placeholder: "Select",
    },
    {
      name: "collateral_description",
      label: "Collateral Description",
      type: "text",
      placeholder: "Enter here",
    },
  ];

  const {
    data: tableData,
    total: totalData,
    currentPage,
    selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
  } = useCommonFetch(getLeaveTypeList, {
    errorMessage: "Failed to fetch leave data!",
    debounceDelay: 500,
    dataTransformer: (data) => {
      const dummyData = [
        {
          id: "12234",
          name: "John Doe",
          phone: "8473847343",
          city: "Engineer",
          created_date: "2025-08-01",
          source: "sadf",
          assign_to: "dcsf",
          status: true,
        },
        {
          id: "122434",
          name: "Jane Smith",
          phone: "7482374383",
          city: "ebhdmc",
          created_date: "2025-08-05",
          source: "dsf",
          assign_to: "fdsc",
          status: false,
        },
      ];

      const finalData =
        Array.isArray(data) && data.length > 0 ? data : dummyData;

      const transformedData = finalData.map((item) => ({
        id: item.id,
        name: { data: item.name, variant: "text" },
        phone: { data: item.phone, variant: "text" },
        city: { data: item.city, variant: "text" },
        created_date: { data: item.created_date, variant: "text" },
        source: { data: item.source, variant: "text" },
        assign_to: { data: item.assign_to, variant: "text" },
        status: {
          data: item.status ? "Approved" : "Pending",
          variant: "status",
        },
      }));

      const actionButton = {
        delete: (item) =>
          handleDelete(item.id.data, deleteDepartment, {
            successMessage: "Department deleted successfully!",
            errorMessage: "Failed to delete department!",
          }),
        edit: (item) => {
          //   setIsEditValue(item);
          openModal(item, actions_type.ADD_EDIT);
        },
      };

      return { data: transformedData, action: actionButton };
    },
  });

  const assignFields = [
    {
      name: "photo",
      label: "Upload Picture",
      type: "file",
      uploadLabel: "Upload Picture",
      accept: [".jpg", ".jpeg", ".png"],
      colSpan: 12,
    },
    {
      sectionTitle: "Personal Details",
    },
    {
      name: "first_name",
      label: "First Name",
      type: "text",
      placeholder: "Enter here",
      required: true,
    },
    {
      name: "last_name",
      label: "Last Name",
      type: "text",
      placeholder: "Enter here",
      required: true,
    },
    {
      name: "phone",
      label: "Phone Number",
      type: "contact",
      placeholder: "Enter here",
      required: true,
    },
    { name: "email", label: "Email", type: "email", placeholder: "Enter here" },
    {
      name: "dob",
      label: "Date Of Birth",
      type: "date",
      placeholder: "Select",
    },
    {
      name: "gender",
      label: "Gender",
      type: "select",
      options: [
        { label: "Male", value: "male" },
        { label: "Female", value: "female" },
        { label: "Other", value: "other" },
      ],
      placeholder: "Select",
    },
    {
      name: "father_name",
      label: "Father Name",
      type: "text",
      placeholder: "Enter here",
    },
    {
      name: "mother_name",
      label: "Mother Name",
      type: "text",
      placeholder: "Enter here",
    },
    {
      name: "nationality",
      label: "Nationality",
      type: "select",
      options: [
        { label: "Indian", value: "indian" },
        { label: "Other", value: "other" },
      ],
      placeholder: "Select",
    },
    {
      name: "state",
      label: "State",
      type: "select",
      options: [
        { label: "State 1", value: "state1" },
        { label: "State 2", value: "state2" },
      ],
      placeholder: "Select",
    },
    { name: "city", label: "City", type: "text", placeholder: "Enter here" },
    {
      name: "pincode",
      label: "Pincode",
      type: "text",
      placeholder: "Enter here",
    },
    {
      name: "current_address",
      label: "Current Address",
      type: "textarea",
      placeholder: "Enter here",
    },
  ];

  const handleAssignSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(false);
    resetForm();
  };

  const handleClose = () => {
    setIsOpenSheet(false);
  };

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader breadcrumbs={breadcrumbs} />
      <div className="bg-white p-4 rounded-md">
        <CommonForm
          fields={leadFormFields}
          initialData={{}}
          onSubmit={handleAssignSubmit}
          submitButtonText="Save"
          columnsPerRow={4}
          gap="gap-4"
          rowClassName=""
          fieldClassName="bg-white p-3 rounded shadow-sm"
        />
      </div>

      <BottomDrawer
        isOpen={isOpenSheet}
        setIsOpen={handleClose}
        title="Add Customer"
        classNames= "!w-[600px]"
        position="right"
      >
        <CommonForm
          fields={assignFields}
          initialData={{}}
          onSubmit={handleAssignSubmit}
          submitButtonText="Save"
          columnsPerRow={2}
          gap="gap-4"
          rowClassName=""
          fieldClassName="bg-white p-3 rounded shadow-sm"
        />
      </BottomDrawer>
    </div>
  );
};

export default AddLeads;
